import { getDateTime } from './getDateTime'
import { getFormattedDate } from './getFormattedDate'
import { getFormattedDateTime } from './getFormattedDateTime'
import { getFormattedDateTimeParts } from './getFormattedDateTimeParts'
import { getFormattedDateTimeRange } from './getFormattedDateTimeRange'
import { getFormattedTime } from './getFormattedTime'
import { parseToDate } from './parseToDate'

export const DateTimeFormat = {
  getDateTime,
  getFormattedDate,
  getFormattedDateTime,
  getFormattedDateTimeParts,
  getFormattedDateTimeRange,
  getFormattedTime,
  parseToDate,
}
